import { Component, Output, EventEmitter } from '@angular/core';
import { PlatformService } from '@panamax/app-state';
import {
  SortableSectionHeader,
  SortDirections,
} from '../models/sortable-section.model';
import { SortableSectionBaseComponent } from '../sortable-section-base.component';

@Component({
  selector: 'app-sortable-section-desktop-tablet',
  templateUrl: './sortable-section-desktop-tablet.component.html',
  styleUrls: ['./sortable-section-desktop-tablet.component.scss'],
})
export class SortableSectionDesktopTabletComponent extends SortableSectionBaseComponent {
  @Output()
  updateSortEventEmitter: EventEmitter<any> = new EventEmitter();
  @Output() headerButtonEventEmitter = new EventEmitter();
  @Output() selectAllEmitter = new EventEmitter();

  constructor(public platformService: PlatformService) {
    super();
  }

  handleUpdateSortEvent(sectionHeader: SortableSectionHeader) {
    this.updateSortEventEmitter.emit({
      headerName: sectionHeader?.headerName,
      sortDirection:
        sectionHeader?.sortDirection === SortDirections.asc
          ? SortDirections.desc
          : SortDirections.asc,
    });
  }

  handleHeaderButtonEvent(event: Event) {
    this.headerButtonEventEmitter.emit(event);
  }

  selectAllClick = () => this.selectAllEmitter.next(undefined);
}
